class ImageOverlaySection extends HTMLElement {
  connectedCallback() {
    this.bg = this.querySelector('.image-overlay__bg');
    if (!this.bg) return;

    this.speed = parseFloat(this.dataset.speed || '0.2');
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.onScroll = this.onScroll.bind(this);

    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onScroll, { passive: true });
    this.reducedMotion.addEventListener('change', this.onScroll);
    this.onScroll();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onScroll);
    this.reducedMotion?.removeEventListener('change', this.onScroll);
  }

  onScroll() {
    if (!this.bg) return;

    if (this.reducedMotion?.matches) {
      this.bg.style.transform = '';
      return;
    }

    const rect = this.getBoundingClientRect();
    const vh = window.innerHeight;

    if (rect.bottom < 0 || rect.top > vh) return;

    const center = rect.top + rect.height / 2;
    const offset = (center - vh / 2) * this.speed;
    this.bg.style.transform = `translate3d(0, ${-offset}px, 0)`;
  }
}

if (!customElements.get('image-overlay-section')) {
  customElements.define('image-overlay-section', ImageOverlaySection);
}
